import { Alert, Typography, Button } from "@mui/material";
import { OpenInNew as OpenInNewIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export const SSMLNestingBanner = () => {
  const { t } = useTranslation();

  const handleCheatSheetClick = () => {
    window.open("/ssml-cheat-sheet", "_blank");
  };

  return (
    <Alert
      severity="info"
      icon={false}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={handleCheatSheetClick}
          endIcon={<OpenInNewIcon />}
          sx={{ whiteSpace: "nowrap" }}
        >
          {t("ssml.nesting.cheatSheet")}
        </Button>
      }
      sx={{
        borderRadius: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        "& .MuiAlert-message": {
          width: "100%",
        },
      }}
    >
      <Typography variant="body2">{t("ssml.nesting.infoBanner")}</Typography>
    </Alert>
  );
};
